import AppErrorBoundary from "./AppErrorBoundary";
import {
  ABOUT_US,
  CAREER,
  CAREER_DETAIL,
  CONTACT_US,
  CONTRACT,
  DASHBOARD,
  ENTRY,
  HOME,
  ONBOARDING,
  JOB,
  PAYMENT,
  PAYMENT_CHECKOUT,
  PRIVACY_POLICY,
  PROFILE,
  PROJECT,
  PROPOSAL,
  PORTFOLIO,
  SETTING,
  TEAM,
  ACCOUNT_MEMBER,
  ACCESS_CONTROL,
  TALENT,
  TERM_AND_CONDITION,
  TRANSACTION,
  ENTRY_REDIRECT,
  INVITATION,
  NOTIFICATION,
  MESSAGE,
} from "constants/urls";
import { createBrowserRouter } from "react-router-dom";
import HomeRoutes from "modules/home/HomeRoutes";
import AuthRoutes from "modules/auth/AuthRoutes";
import OnboardingRoutes from "./modules/onboarding/OnboardingRoutes";
import ProfileRoutes from "modules/profile/ProfileRoutes";
import JobRoutes from "modules/job/JobRoutes";
import projectRoutes from "modules/project/ProjectRoutes";
import TalentRoutes from "modules/talent/TalentRoutes";
import SettingRoutes from "modules/setting/SettingRoutes";
import PaymentRoutes from "modules/payment/PaymentRoutes";
import paymentCheckoutRoutes from "modules/payment/PaymentCheckoutRoutes";
import ContractRoutes from "modules/contract/ContractRoutes";
import ProposalRoutes from "modules/proposal/ProposalRoutes";
import TeamRoutes from "modules/team/TeamRoutes";
import AccountMemberRoutes from "modules/account-member/AccountMemberRoutes";
import AccessControlRoutes from "modules/access-control/AccessControlRoutes";
import PortfolioRoutes from "modules/portfolio/PortfolioRoutes";
import TransactionRoutes from "modules/transaction/TransactionRoutes";
import InvitationRoutes from "modules/invitation/InvitationRoutes";
import NotificationRoutes from "modules/notification/NotificationRoutes";
import MessageRoutes from "modules/message/MessageRoutes";

const router = createBrowserRouter([
  {
    path: ENTRY,
    lazy: () => import("./App"),
    ErrorBoundary: AppErrorBoundary,
    children: [
      {
        path: ENTRY_REDIRECT,
        lazy: () => import("./AppRedirect"),
      },
      {
        lazy: () => import("./AppPublic"),
        children: [
          {
            lazy: () => import("./modules/auth/Auth"),
            children: AuthRoutes,
          },
          {
            lazy: () => import("./AppPublicWithNavigation"),
            children: [
              {
                path: HOME,
                lazy: () => import("./modules/home/Home"),
                children: HomeRoutes,
              },
              {
                path: CAREER,
                lazy: () => import("modules/career/Careers"),
              },
              {
                path: CAREER_DETAIL,
                lazy: () => import("modules/career/CareerDetail"),
              },
              {
                path: ABOUT_US,
                lazy: () => import("modules/about-us/AboutUs"),
              },
              {
                path: CONTACT_US,
                lazy: () => import("modules/contact-us/ContactUs"),
              },
              {
                path: PRIVACY_POLICY,
                lazy: () => import("modules/privacy-policy/PrivacyPolicy"),
              },
              {
                path: TERM_AND_CONDITION,
                lazy: () =>
                  import("modules/term-and-condition/TermAndCondition"),
              },
            ],
          },
        ],
      },
      {
        lazy: () => import("./AppProtected"),
        children: [
          {
            path: ONBOARDING,
            lazy: () => import("modules/onboarding/Onboarding"),
            children: OnboardingRoutes,
          },
          {
            lazy: () => import("./AppProtectedWithNavigation"),
            children: [
              {
                path: DASHBOARD,
                lazy: () => import("modules/dashboard/Dashboard"),
              },
              {
                path: PROFILE,
                lazy: () => import("modules/profile/Profile"),
                children: ProfileRoutes,
              },
              {
                path: JOB,
                lazy: () => import("modules/job/Job"),
                children: JobRoutes,
              },
              {
                path: CONTRACT,
                lazy: () => import("modules/contract/Contract"),
                children: ContractRoutes,
              },
              {
                path: INVITATION,
                lazy: () => import("modules/invitation/Invitation"),
                children: InvitationRoutes,
              },
              {
                path: NOTIFICATION,
                lazy: () => import("modules/notification/Notification"),
                children: NotificationRoutes,
              },
              {
                path: MESSAGE,
                lazy: () => import("modules/message/Message"),
                children: MessageRoutes,
              },
              {
                path: TALENT,
                lazy: () => import("modules/talent/Talent"),
                children: TalentRoutes,
              },
              {
                path: SETTING,
                lazy: () => import("modules/setting/Setting"),
                children: SettingRoutes,
              },
              {
                path: TEAM,
                lazy: () => import("modules/team/Team"),
                children: TeamRoutes,
              },
              {
                path: ACCOUNT_MEMBER,
                lazy: () => import("modules/account-member/AccountMember"),
                children: AccountMemberRoutes,
              },
              {
                path: ACCESS_CONTROL,
                lazy: () => import("modules/access-control/AccessControl"),
                children: AccessControlRoutes,
              },
              {
                path: PAYMENT,
                lazy: () => import("modules/payment/Payment"),
                children: PaymentRoutes,
              },
              {
                path: PROJECT,
                lazy: () => import("modules/project/Project"),
                children: projectRoutes,
              },
              {
                path: PROPOSAL,
                lazy: () => import("modules/proposal/Proposal"),
                children: ProposalRoutes,
              },
              {
                path: PORTFOLIO,
                lazy: () => import("modules/portfolio/Portfolio"),
                children: PortfolioRoutes,
              },
              {
                path: TRANSACTION,
                lazy: () => import("modules/transaction/Transaction"),
                children: TransactionRoutes,
              },
            ],
          },
        ],
      },
      {
        path: PAYMENT_CHECKOUT,
        lazy: () => import("modules/payment/Payment"),
        children: paymentCheckoutRoutes,
      },
    ],
  },
]);

export default router;
